const DEBIT_NOTE_API = {
	// POST /api/debitnote/...
	DEBIT_NOTE_NO: 'api/debitnote/getDebitNoteMaxNo',
	SAVE_DEBIT_NOTE: 'api/debitnote/saveDebitNote',
	UPDATE_DEBIT_NOTE: 'api/debitnote/updateDebitNote',
	DEBIT_NOTE_LIST: 'api/debitnote/getDebitNoteList',
	EDIT_DEBIT_NOTE: 'api/debitnote/getDebitNoteEditLoad',
	DELETE_DEBIT_NOTE: 'api/debitnote/deleteDebitNote',
	PRINT_DEBIT_NOTE: 'api/debitnote/getDebitNotePrint',
};

export default DEBIT_NOTE_API;
